/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Carriedoutsusworkshoplearningtolearn7Inputs */

const de__field_carriedoutsusworkshoplearningtolearn7 = /** @type {(inputs: _Field_Carriedoutsusworkshoplearningtolearn7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchgeführt SuS-Workshop Learning To Learn`)
};

/**

* @param {_Field_Carriedoutsusworkshoplearningtolearn7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_carriedoutsusworkshoplearningtolearn7 = /** @type {((inputs?: _Field_Carriedoutsusworkshoplearningtolearn7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Carriedoutsusworkshoplearningtolearn7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_carriedoutsusworkshoplearningtolearn7(inputs)
});
export { _field_carriedoutsusworkshoplearningtolearn7 as "_field_carriedOutSuSWorkshopLearningToLearn" }